import apiClient from '@/lib/api-client';

export type BillingFieldName = 'address' | 'zipCode' | 'city' | 'poReference';

export interface BillingFieldChange {
  field: BillingFieldName;
  from: string | null;
  to: string;
}

export interface BillingAddress {
  address: string | null;
  zipCode: string | null;
  city: string | null;
}

export interface BillingDetails {
  address: BillingAddress | null;
  /** Informative only — h12-0 contract: there is no master default-PO value. */
  lastUsedPoReference: string | null;
  openRequest: {
    changes: BillingFieldChange[];
    status: 'submitted' | 'processed';
    submittedAt: string;
  } | null;
}

export interface BillingDetailsEnvelope {
  data: BillingDetails | null;
  meta: {
    noBillingLink?: boolean;
    degraded?: boolean;
  };
}

export interface BillingChangeInput {
  address?: string;
  zipCode?: string;
  city?: string;
  poReference?: string;
}

/** Tenant identity is always the session — this call intentionally carries no gln/companyId. */
export async function getBillingDetails(): Promise<BillingDetailsEnvelope> {
  const response = await apiClient.get<BillingDetailsEnvelope>('/billing-details');
  return response.data;
}

export async function submitBillingChange(input: BillingChangeInput): Promise<BillingDetailsEnvelope> {
  const response = await apiClient.post<BillingDetailsEnvelope>('/billing-details/change', input);
  return response.data;
}
